import React from 'react';
import { makeStyles } from '@smile-next/uikit';

const useStyles = makeStyles(() => ({
    root: {
        width: 506,
    },
}));

export const LoginForm: React.FC = (props) => {
    const classes = useStyles(props);
    return <div className={classes.root}>{props.children}</div>;
};
